import { tv } from 'tailwind-variants';

const messageInputStyles = tv({
    slots: {
        container: `
      iris:flex
      iris:min-h-(--comp-size-height-message-input)
      iris:items-start
      iris:gap-(--comp-space-gap-message-input-button)
      iris:rounded-(--comp-size-radius-message-input)
      iris:border-(length:--comp-size-border-message-input)
      iris:border-(--comp-color-border-message-input-rest)  
      iris:bg-(--comp-color-background-message-input-rest)
      iris:pt-(--comp-space-padding-message-input-top)
      iris:pr-(--comp-space-padding-message-input-right)
      iris:pb-(--comp-space-padding-message-input-bottom)
      iris:pl-(--comp-space-padding-message-input-left)
      iris:transition-all
      iris:duration-(--comp-motion-duration-message-input)
      iris:ease-(--comp-motion-easing-message-input)
    `,
        input: `
      iris:scrollbar-thin
      iris:scrollbar-track-transparent
      iris:scrollbar-thumb-rounded-full
      iris:scrollbar-thumb-(--base-color-neutral-400)
      iris:max-h-[300px]
      iris:w-full
      iris:flex-1
      iris:resize-none
      iris:px-(--base-space-px-0)
      iris:py-(--comp-space-padding-message-input-text-area-vertical)
      iris:font-(family-name:--comp-type-font-message-input-value)
      iris:text-(length:--comp-type-size-message-input-value)
      iris:leading-(--comp-type-leading-message-input-value)
      iris:font-(--comp-type-weight-message-input-value)!
      iris:tracking-(--comp-type-tracking-message-input-value)
      iris:text-(--comp-color-content-message-input-value)
      iris:transition-all
      iris:duration-(--comp-motion-duration-message-input)
      iris:ease-(--comp-motion-easing-message-input)
      iris:outline-none
      iris:placeholder:font-(family-name:--comp-type-font-message-input-placeholder)
      iris:placeholder:text-(length:--comp-type-size-message-input-placeholder)
      iris:placeholder:leading-(--comp-type-leading-message-input-placeholder)
      iris:placeholder:font-(--comp-type-weight-message-input-placeholder)!
      iris:placeholder:tracking-(--comp-type-tracking-message-input-value)
      iris:placeholder:text-(--comp-color-content-message-input-placeholder)
      iris:[&::-webkit-scrollbar]:h-1.5
      iris:[&::-webkit-scrollbar]:w-1.5
      iris:[&::-webkit-scrollbar-thumb]:rounded-full
      iris:[&::-webkit-scrollbar-thumb]:bg-(--base-color-neutral-400)
      iris:[&::-webkit-scrollbar-thumb:hover]:bg-(--base-color-neutral-500)
      iris:[&::-webkit-scrollbar-track]:bg-transparent
    `,
        buttonWrapper: `
      iris:flex
      iris:shrink-0
      iris:self-end 
    `,
    },
    variants: {
        inverse: {
            true: {
                container: `
          iris:border-(--comp-color-border-message-input-inverse-rest)
          iris:bg-(--comp-color-background-message-input-inverse-rest)
          iris:focus-within:border-(--comp-color-border-message-input-inverse-active)
          iris:focus-within:bg-(--comp-color-background-message-input-inverse-active)
          iris:hover:border-(--comp-color-border-message-input-inverse-hover)
          iris:hover:bg-(--comp-color-background-message-input-inverse-hover)
          iris:focus-within:hover:border-(--comp-color-border-message-input-inverse-active)
          iris:focus-within:hover:bg-(--comp-color-background-message-input-inverse-active)
          iris:has-[textarea:focus-visible]:ring-2
          iris:has-[textarea:focus-visible]:ring-(--sem-color-border-interactive-inverse-selected)
          iris:has-[textarea:focus-visible]:ring-offset-2
          iris:has-[textarea:focus-visible]:ring-offset-(--sem-color-background-neutral-inverse-primary)
        `,
                input: `
          iris:font-(family-name:--comp-type-font-message-input-value)
          iris:text-(length:--comp-type-size-message-input-value)
          iris:leading-(--comp-type-leading-message-input-value)
          iris:font-(--comp-type-weight-message-input-value)!
          iris:tracking-(--comp-type-tracking-message-input-value)
          iris:text-(--comp-color-content-message-input-value-inverse)
          iris:placeholder:font-(family-name:--comp-type-font-message-input-placeholder)
          iris:placeholder:text-(length:--comp-type-size-message-input-placeholder)
          iris:placeholder:leading-(--comp-type-leading-message-input-placeholder)
          iris:placeholder:font-(--comp-type-weight-message-input-placeholder)!
          iris:placeholder:tracking-(--comp-type-tracking-message-input-placeholder)
          iris:placeholder:text-(--comp-color-content-message-input-placeholder-inverse)
        `,
            },
            false: {
                container: `
          iris:focus-within:border-(--comp-color-border-message-input-active)
          iris:focus-within:bg-(--comp-color-background-message-input-active)
          iris:hover:border-(--comp-color-border-message-input-hover)
          iris:hover:bg-(--comp-color-background-message-input-hover)
          iris:focus-within:hover:border-(--comp-color-border-message-input-active)
          iris:focus-within:hover:bg-(--comp-color-background-message-input-active)
          iris:has-[textarea:focus-visible]:ring-2
          iris:has-[textarea:focus-visible]:ring-(--sem-color-border-interactive-selected)
          iris:has-[textarea:focus-visible]:ring-offset-2
        `,
            },
        },
        isKeyboardFocus: {
            true: {},
            false: {
                container: `
          iris:has-[textarea:focus-visible]:ring-0
          iris:has-[textarea:focus-visible]:ring-offset-0
        `,
            },
        },
    },
    defaultVariants: {
        inverse: false,
    },
});

export { messageInputStyles as default };
